<template>
  <div class="maskBox"  @click="close">
    <div class="NoSpinChancesYet" @click.stop>
      <div class="title">{{$t('lang.cashWheel.noSpinChancesYet')}}</div>
      <div class="Btn" @click.stop="earnChance">{{$t('lang.cashWheel.earnChance')}}</div>
      <div class="BtnBox" @click.stop="close">
        <div class="Btn2">{{$t('lang.cashWheel.close')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modalBox-NoSpinChancesYet',
  data () {
    return {}
  },
  methods: {
    close () {
      this.$emit('closeNoSpinChancesYet')
    },
    earnChance () {
      this.$emit('earnChanceNoSpinChancesYet')
    }
  }
}
</script>

<style lang="less" scoped>
.maskBox{
  height: 100vh;
  width: 100%;
  position: fixed;
  background-color: rgba(0,0,0,0.8);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes expandBox {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.NoSpinChancesYet{
  width: 82.233vw;
  height: 66.94vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: expandBox 0.2s ease-out forwards;
  border: 1px solid #888888;
  border-right: 2px solid #888888;
  border-left: 2px solid #888888;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 1.243vw;
  .title{
    width: 45.27vw;
    color: #D9D9D9;
    font-size: 5.277vw;
    font-weight: 700;
    text-align: center;
    position: relative;
    top: 10vw;
  }
  .Btn{
    width: 65.913vw;
    height: 10.833vw;
    color: #000000;
    font-size: 4.44vw;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    top: 19.8vw;
    background: linear-gradient(90deg, #01B7D3 0%, #13C498 100%), #F1DAB0;
    border-radius: 1.388vw;
  }
  .BtnBox{
    width: 65.913vw;
    height: 10.833vw;
    //background-color: #F1DAB0;
    border-radius: 1.5vw;
    color: #898989;
    font-size: 4.44vw;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.3vw;
    position: relative;
    border: 1px solid #898989;
    top: 22vw;
    .Btn2{
      height: 100%;
      width: 100%;
      //background-color: #181818;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 1.5vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cashWheel/modalBox-NoSpinChancesYet.vue